<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    buttonTitle: {
      type: String,
      default: null,
    },
    onButtonActivate: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: null,
    },
    maxWidth: {
      type: [String, Number],
      default: '500',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    dialog: false,
    message: null,
    uploading: false,
  }),

  watch: {
    value(val) {
      this.dialog = val
    },
    dialog(val) {
      this.$emit('input', val)
      this.message = null
    },
  },

  methods: {
    close() {
      this.uploading = false
      this.dialog = false
    },
  },
}
</script>
